//**Autentificación por medio de acceso de usuario y contraseña

//*react- recursos
  import { useState } from 'react';
  import { useHistory } from "react-router-dom"; 
  import { Form, Formik, Field, ErrorMessage } from 'formik';
  import * as Yup from 'yup';
  import base64 from  'react-native-base64';

//*componentes-utiles

//*archivos (imagenes y elementos necesarios para la rutina)
  import logoProyecto from '../../imagenes/proyecto/SSC_logo.png'; 
  import logoInegi from '../../imagenes/inegi/INEGI_LogoV.png';
  import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
  import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';


//*api's (servicios y store)
  import autenticateServicio from "../../api/recursos/authenticate/authenticate.servicio";
  import authenticateStore from "../../api/recursos/authenticate/authenticate.store";

//*datos: mis etiqueta
  import etiquetasSSC from "../../datos/json/etiquetasSSC.json"

//*funciones

//*componente
  export default function Autenticar(){

    //*api store
      const {guardaAuthStore, generaobjErrorAuthenticateStore, objErrorAuthenticateStore} =  
        authenticateStore((state:any) =>( {
          guardaAuthStore: state.guardaAuthStore,
          generaobjErrorAuthenticateStore: state.generaobjErrorAuthenticateStore,
          objErrorAuthenticateStore: state.objErrorAuthenticateStore
      }));

    //*datos: mis etiquetas
      let eti = etiquetasSSC.Autenticacion;
    
    //*constantes y variables
      const APP_ENV=process.env.REACT_APP_ENV;
      const API_APP=process.env.REACT_APP_ENV

      //let rutaNAS:any = process.env.REACT_APP_SERV_HOSTNAME ;
      let terminos =  process.env.REACT_APP_DOCS + 'Terminosycondiciones_SSC.pdf';
      

      const [pestanaActiva, setPestanaActiva] = useState((APP_ENV=='LOCAL' || APP_ENV=='PRE66' ) ? "usuarioDePrueba" : "iniciarSesion");
      
      let claseActiva = "activeAut";
      let claseInActiva = "inactiveAut";
      
      let history = useHistory(); //variable tipo useHistory que cambia a la página homeprocess cuando pasa autenticar
      
    //*usestate
     // const [opc, setOpc] = useState(pestanaActiva); //si estamos en dev (mtto) el marcador entra en s = iniciar sesion .. sino en p= Usuario de pruebas
      const [claseIS, setClaseIS] = useState((pestanaActiva=="iniciarSesion") ? claseActiva : claseInActiva);
      const [claseUSP, setClaseUSP] = useState((pestanaActiva=="usuarioDePrueba") ? claseActiva : claseInActiva);

      const [showPassword, setShowPassword] = useState(false);
      const toggleShowPassword = () => setShowPassword(!showPassword);


    //*useEffect
      
    //*funciones
      const cambiaEntradaUsuario=(option:any)=> { //cambios de ligas de iniciar sesión, usuario de prueba
          switch(option){
            case "iniciarSesion":
              setClaseIS(claseActiva);
              setClaseUSP(claseInActiva);
            break;
            case "usuarioDePrueba": 
              setClaseIS(claseInActiva);
              setClaseUSP(claseActiva);
            break;
          }
          setPestanaActiva(option)
      }
      
    //*vista
      return (
        <>
          <div className="homeFather">
            <div className="homeChild  scrollAuto">
             
              <div className={APP_ENV?.toLowerCase().includes("training") ? "block align-3 alert alert-danger2 training":"hide"} dangerouslySetInnerHTML={{__html: eti[4].text}}></div>
              <div className="imagenlogo"></div>
              <Formik initialValues={{
                    usuario:'',
                    password:''
                    }}
                    onSubmit= {async values => {

                        /* OJO: ACTIVAR con esto evitamos que un usuario tenga mas de una sesión abierta a la vez, activar en su momento 1/2 */
                        /* if (localStorage.usuario!=undefined){
                            let datoUsuario;
                            datoUsuario = JSON.parse(localStorage.getItem('usuario')!);
                            sessionStorage.setItem('usuario', JSON.stringify(datoUsuario));
                            alert("Se tiene una session iniciada");
                            return;
                        } 
                        */
                        let usuario= values.usuario;

                        let API_BODY:any={};
                        //API_BODY={"User":base64.encode(values.usuario),"Pass":base64.encode(values.password), "Esquema":process.env.REACT_APP_API_SCHEMA, "encrypted": true};  //error al convertir Ñ ñ en base 64
                        //API_BODY={"User":base64.encode(values.usuario),"Pass":base64.encode(unescape(encodeURIComponent(values.password))), "Esquema":process.env.REACT_APP_API_SCHEMA, "encrypted": true}; //marca obsoleto unescape aunque si funciona
                        const utf8Bytes:any = new TextEncoder().encode(values.password);
                        const utf8BytesUsu:any = new TextEncoder().encode(values.usuario);
                        API_BODY={"User":base64.encode(values.usuario),"Pass":base64.encode(String.fromCharCode(...utf8Bytes)), "Esquema":process.env.REACT_APP_API_SCHEMA, "encrypted": true}; 
                        //let binaryString:any = '';  //otra opción
                        //utf8Bytes.forEach(byte => { binaryString += String.fromCharCode(byte) });
                        //API_BODY={"User":base64.encode(values.usuario),"Pass":base64.encode(String.fromCharCode(binaryString)), "Esquema":process.env.REACT_APP_API_SCHEMA, "encrypted": true}; 
                        //console.log('-----------API_BODY: ', API_BODY)
                        //alert(API_BODY.Pass);

                        { pestanaActiva == 'usuarioDePrueba'
                          ? ( autenticateServicio.cargaAuth(API_BODY)
                              .then((response:any) => {
                                  if (response.status===200) {
                                    guardaAuthStore(response, usuario); //manda el resultado al apiStore para guardar su información o el objeto de error que generó
                                 
                                    //guarda la información en variables storage
                                      let storage = {
                                        userName: usuario,
                                        //userNameEncripted: base64.encode(values.usuario),
                                        token: "bearer " + response.data.value,
                                        //tokenEncripted:  base64.encode(response.data.value),
                                      }

                                    /* OJO: ACTIVAR 2/2 */  
                                    /* sessionStorage.setItem('usuario', JSON.stringify(storage));
                                      localStorage.setItem('usuario', JSON.stringify(storage)); */

                                    //se cambia de página - avanza a la siguiente página
                                      //history.push("/HomeProcess"); 
                                      history.push("/PaginaSSC"); 
                                  }

                              })
                              .catch((ex) => { //Bety esto esta bien??
                                  let body = "{ user: " + values.usuario + ", pass: " + '***** }'
                                  //ex.response.data.result.errores.map((err: any) => (
                                  //toast.error(err.errorMessage)))
                                  console.log ("catch - ex.......", ex);
                                  generaobjErrorAuthenticateStore(ex.response, true, '', body, 'Autenticacion', 'A')
                              })
                          )    
                          : ( autenticateServicio.cargaAuthLDAP(API_BODY)
                              .then((response:any) => {
                                  if (response.status===200) {
                                    guardaAuthStore(response, usuario); //manda el resultado al apiStore para guardar su información o el objeto de error que generó
                                 
                                    //guarda la información en variables storage
                                      let storage = {
                                        userName: usuario,
                                        //userNameEncripted: base64.encode(values.usuario),
                                        token: "bearer " + response.data.value,
                                        //tokenEncripted:  base64.encode(response.data.value),
                                      }

                                    /* OJO: ACTIVAR 2/2 */  
                                    /* sessionStorage.setItem('usuario', JSON.stringify(storage));
                                      localStorage.setItem('usuario', JSON.stringify(storage)); */

                                    //se cambia de página - avanza a la siguiente página
                                      //history.push("/HomeProcess"); 
                                      history.push("/PaginaSSC"); 
                                  }
                              })
                              .catch((ex) => { //Bety esto esta bien?? 
                                  let body = "{ user: " + values.usuario + ", pass: " + '***** }'
                                  //ex.response.data.result.errores.map((err: any) => (
                                  //toast.error(err.errorMessage)))
                                  console.log ("catch - ex.......", ex);
                                  generaobjErrorAuthenticateStore(ex.response, true, '', body, 'Autenticacion', 'A')
                            })
                          )  
                        }    
                    } }

                    validationSchema={Yup.object({
                      usuario: Yup.string().required('Campo requerido'),
                      password: Yup.string().required('Campo requerido')
                    })}
                >
                <Form>
                  <div className="margin-6rem">
                      {/* Pestaña de Inicio y usuario */}
                        <div id="optionsAut" > 
                        
                          { API_APP == 'PRODUCTIVODESARROLLO' &&  (<> <p className='color-red'>SITIO PRODUCTIVO DESARROLLO <br /></p></>) }
                          <ul className="nav2">
                            <li className={claseIS} >
                              <a href="#" onClick={()=>cambiaEntradaUsuario("iniciarSesion")} > {eti[0].text}  </a>
                            </li>
                            
                            { API_APP != 'PRODUCTIVODOMINIO' &&
                              (<>
                               {/*{ API_APP != 'PRODUCTIVODESARROLLO' &&
                                    (<> */}
                                      <li className={claseUSP} >
                                        <a href="#" onClick={()=>cambiaEntradaUsuario("usuarioDePrueba")} > {eti[1].text} </a>
                                      </li>
                                {/* </>)
                                } */}
                              </>)       
                            }
                          </ul>  
                        </div>

                      {/*Input de Usuario*/}
                        <label htmlFor="usuario">{eti[2].text}</label>
                        <Field type="text" name="usuario"  className="form-control text-center mb-1" placeholder={eti[2].text}/>
                        <ErrorMessage name="usuario">
                            {mensaje =>
                              <span className="">
                                <div className="alert alert-warning heigth-1">
                                  <div className="margin-top-1">{mensaje}</div>
                                </div>
                              </span>
                            }
                        </ErrorMessage>

                      {/*Input de Contraseña */}
                        {/* <label htmlFor="password">{eti[3].text}</label>
                        <Field type="password" name="password" className="form-control text-center mb-1" placeholder={eti[3].text}/>
                        <ErrorMessage name="password">{mensaje =>
                            <span className=""><div className="alert alert-warning heigth-1">
                                <div className="margin-top-1">{mensaje}</div></div></span>}
                        </ErrorMessage> */}
                        <div className="form-group">
                          <label htmlFor="password">{eti[3].text}</label>

                          <div className="password-input-container" style={{ position: 'relative' }}>
                            {/* Campo controlado por Formik */}
                            <Field
                              type={showPassword ? 'text' : 'password'}
                              name="password"
                              id="password"
                              className="form-control text-center mb-1"
                              placeholder={eti[3].text}
                            />

                            {/* Botón con el icono del ojo */}
                            <button
                              type="button"
                              className="toggle-password-visibility"
                              onClick={toggleShowPassword}
                              style={{
                                position: 'absolute',
                                right: '10px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                background: 'none',
                                border: 'none',
                                cursor: 'pointer',
                                color: '#666',
                              }}
                            >
                              <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                            </button>
                          </div>

                          {/* Mensaje de error de Formik */}
                          <ErrorMessage name="password">
                            {(mensaje) => (
                              <div className="alert alert-warning heigth-1 mt-1">
                                <div className="margin-top-1">{mensaje}</div>
                              </div>
                            )}
                          </ErrorMessage>
                        </div>


                      {/*botón iniciar sesión */}
                        <button type= "submit" className="btn-login mt-5 mb-2">Iniciar sesión </button>

                      {/* mensaje  */}
                        <div className='mb-2' dangerouslySetInnerHTML={{__html: eti[5].text}}></div>

                      {/* logo inegi & liga terminos y condiciones  */}
                        {/* <img src={logoInegi} alt="logo INEGI" className="logoInegi" /><br/> */}
                        <div className="imagenlogoh"></div>
                        <p><a target="_blank" href={terminos} className="text-decoration-none"> Términos y condiciones de uso </a></p>

                  </div>
                </Form>
              </Formik>
            </div> 
          </div>
          
        </>
      );
  }

